"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useNavigator = () => {
  const [isSafari, setIsSafari] = (0, _react.useState)(false);
  const [isIos, setIos] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined" && typeof navigator !== "undefined") {
      setIos(Boolean(navigator.userAgent.match(/iPhone|iPad|iPod/i)));
      setIsSafari(Boolean(navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)));
    }
  }, []);
  return {
    isSafari,
    isIos
  };
};
var _default = useNavigator;
exports.default = _default;